// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__Zqe7e","rootSuccess":"CompleteLink_rootSuccess__1v07J","rootFailure":"CompleteLink_rootFailure__NMmdb","isDisabled":"CompleteLink_isDisabled__iieI9"};